/* kinddot. – Appstle "Buy X Get Y" (2+1) widget helpers.
   The app's own (React) markup only gets data attributes and native input events; our header lives outside it:
   an optional, collapsed 2+1 card ("arba" divider, title, savings, toggle), step labels + counter,
   and the current product preselected first with the size chosen in the main picker. */
/* kinddot. – product page (desktop, two columns): the gallery follows the scroll like the info column.
   Top offset = header + 20px; a gallery taller than the window scrolls through first and then sticks by its bottom edge, so it is never cut off. */
(function () {
  var gal = document.querySelector('.thb-product-detail .product-grid-container > :first-child > .product-image-container');
  if (!gal || !window.matchMedia) return;
  var mq = matchMedia('(min-width: 1068px)'), raf = 0;
  function set() {
    raf = 0;
    if (!mq.matches) { gal.style.removeProperty('--kd-gal-top'); return; }
    var head = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-height')) || 80;
    var top = Math.min(head + 20, window.innerHeight - gal.offsetHeight - 20);
    gal.style.setProperty('--kd-gal-top', Math.round(top) + 'px');
  }
  function queue() { if (!raf) raf = requestAnimationFrame(set); }
  if (window.ResizeObserver) new ResizeObserver(queue).observe(gal);
  window.addEventListener('resize', queue, { passive: true });
  set();
})();

(function () {
  var root = document.getElementById('ab-bogo-discount-product-page');
  /* release the reserved space / hidden widget if no offer gets built (no rule for this product, app off) */
  function release() { document.documentElement.classList.add('kd-ab-off'); }
  if (!root) { release(); return; }
  setTimeout(function () { if (!root.parentElement.hasAttribute('data-kd-ready')) release(); }, 6000);
  var en = (document.documentElement.lang || '').indexOf('en') === 0;
  var T = en
    ? { or: 'or take the 2+1 offer', open: 'Build your 2+1 set', close: 'Hide', save: function (v, upTo) { return 'Pick 2 items and 1 more free – save ' + (upTo ? 'up to ' : '') + '<b>' + v + '</b>'; }, tag: '2+1', pick: function (c, n) { return '1. Choose ' + n + ' items · ' + c + '/' + n; }, gift: '2. Choose your free gift', giftWait: '2. Free gift – choose the first items above' }
    : { or: 'arba pasinaudok 2+1 pasiūlymu', open: 'Sudaryti 2+1 rinkinį', close: 'Suskleisti', save: function (v, upTo) { return 'Išsirink 2 prekes ir dar 1 gauk dovanų – sutaupysi ' + (upTo ? 'iki ' : '') + '<b>' + v + '</b>'; }, tag: '2+1', pick: function (c, n) { return '1. Pasirink ' + n + ' prekes · ' + c + '/' + n; }, gift: '2. Pasirink dovaną', giftWait: '2. Dovana – pirma pasirink prekes viršuje' };
  var handle = (location.pathname.match(/\/products\/([^/?#]+)/) || [])[1];
  var preselected = false;
  var card = root.parentElement;
  var chevron = '<svg viewBox="0 0 12 12" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true"><path d="M2 4.5 6 8.5l4-4"/></svg>';

  function money(text) { return parseFloat(String(text).replace(/[^\d,.]/g, '').replace(/\.(?=\d{3})/g, '').replace(',', '.')) || 0; }

  /* "save up to X": the highest gift price; recomputed on every render because the app fills the gift list progressively */
  function saveText(content, get) {
    var prices = [].map.call((get || content).querySelectorAll('.ab-bogo-product-original-price'), function (el) { return { v: money(el.textContent), t: el.textContent.trim() }; });
    if (!prices.length) return '';
    var max = prices.reduce(function (a, b) { return b.v > a.v ? b : a; });
    var upTo = prices.some(function (p) { return p.v !== max.v; });
    return T.save(max.t.replace(/\s/g, ' '), upTo);
  }

  /* our header: built once the app has rendered the offer (no rule → nothing is shown) */
  function buildHead(content, get) {
    if (card.hasAttribute('data-kd-ready')) return;
    var title = (content.querySelector('.ab-bogo-title') || {}).textContent || '';
    var save = saveText(content, get);
    if (!save) return;
    var or = document.createElement('div');
    or.className = 'kd-ab-or';
    or.textContent = T.or;
    card.parentNode.insertBefore(or, card);
    /* same space under the divider as above it (the space above comes from the buy button's own margin) */
    var prev = or.previousElementSibling;
    while (prev && !prev.getBoundingClientRect().height) prev = prev.previousElementSibling;
    if (prev) { var gap = Math.round(or.getBoundingClientRect().top - prev.getBoundingClientRect().bottom); if (gap > 0 && gap < 60) or.style.marginBottom = gap + 'px'; }
    var head = document.createElement('div');
    head.className = 'kd-ab-head';
    head.innerHTML = '<span class="kd-ab-tag">' + T.tag + '</span><span class="kd-ab-title"></span><span class="kd-ab-sub">' + save + '</span>' +
      '<button type="button" class="kd-ab-toggle" aria-expanded="false"><span>' + T.open + '</span>' + chevron + '</button>';
    head.querySelector('.kd-ab-title').textContent = title.trim();
    card.insertBefore(head, root);
    card.classList.add('kd-ab-card');
    card.setAttribute('data-kd-ready', '');
    var btn = head.querySelector('.kd-ab-toggle');
    btn.addEventListener('click', function () {
      var open = !card.hasAttribute('data-kd-open');
      btn.setAttribute('aria-expanded', open);
      btn.firstChild.textContent = open ? T.close : T.open;
      slide(open);
      var list = active && active.querySelector(':scope > .ab-bogo-products');
      if (list) list.scrollLeft = 0;
    });
  }

  /* smooth expand/collapse: animate the height between 0 and the content height, then hand back to auto */
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var slideEnd = null;
  function slide(open) {
    if (slideEnd) slideEnd();
    if (reduce) { card.toggleAttribute('data-kd-open', open); refreshArrows(); return; }
    var from, to;
    if (open) { card.setAttribute('data-kd-open', ''); from = 0; to = root.scrollHeight; refreshArrows(); }
    else { from = root.offsetHeight; to = 0; }
    card.setAttribute('data-kd-anim', '');
    root.style.height = from + 'px';
    root.style.opacity = open ? '0' : '1';
    root.offsetHeight;
    root.style.height = to + 'px';
    root.style.opacity = open ? '1' : '0';
    var timer;
    slideEnd = function () {
      clearTimeout(timer);
      root.removeEventListener('transitionend', onEnd);
      slideEnd = null;
      if (!open) card.removeAttribute('data-kd-open');
      card.removeAttribute('data-kd-anim');
      root.style.height = root.style.opacity = '';
    };
    function onEnd(e) { if (e.target === root && e.propertyName === 'height') slideEnd(); }
    root.addEventListener('transitionend', onEnd);
    timer = setTimeout(function () { if (slideEnd) slideEnd(); }, 600);
  }

  function setSelect(sel, value) {
    if (!sel || !value || sel.value === String(value)) return;
    if (![].some.call(sel.options, function (o) { return o.value === String(value); })) return;
    var setter = Object.getOwnPropertyDescriptor(HTMLSelectElement.prototype, 'value').set;
    setter.call(sel, String(value));
    sel.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function mainVariant() {
    var input = document.querySelector('product-form form input[name="id"], form[action*="/cart/add"] input[name="id"]');
    return input && input.value;
  }

  function currentCard(list) {
    if (!handle || !list) return null;
    var links = list.querySelectorAll('.ab-bogo-product-link');
    for (var i = 0; i < links.length; i++) {
      var href = links[i].getAttribute('href') || '';
      if (href.indexOf('/products/' + handle) > -1) return links[i].closest('.ab-bogo-product-container');
    }
    return null;
  }

  /* several offers can render in the one block (e.g. kids tees are a gift in the adult offer and the product in the kids offer):
     show the offer whose "buy" list holds this product, hide the rest */
  var active = null;
  function pickOffer() {
    var all = root.querySelectorAll('.ab-bogo-bundle-content');
    if (!all.length) return null;
    var pick = null;
    for (var i = 0; i < all.length && !pick; i++) {
      if (currentCard(all[i].querySelector(':scope > .ab-bogo-products'))) pick = all[i];
    }
    pick = pick || all[0];
    for (var j = 0; j < all.length; j++) {
      var box = all[j].closest('#ab-bogo-discount-container') || all[j];
      var hide = all[j] !== pick;
      if (box.hasAttribute('data-kd-hidden') !== hide) box.toggleAttribute('data-kd-hidden', hide);
      if (hide && box.style.display !== 'none') box.style.display = 'none';
      if (!hide && box.style.display === 'none') box.style.display = '';
    }
    active = pick;
    return pick;
  }

  /* the app renders original uploads (up to ~5000px, ~10 MB per offer) – request a card-sized rendition from the Shopify CDN */
  function shrinkImages() {
    var imgs = root.querySelectorAll('img');
    for (var i = 0; i < imgs.length; i++) {
      var img = imgs[i], src = img.getAttribute('src') || '';
      if (!src || src.indexOf('cdn.shopify.com') < 0 && src.indexOf('/cdn/shop/') < 0 || /[?&]width=/.test(src)) continue;
      if (!img.hasAttribute('decoding')) img.setAttribute('decoding', 'async');
      img.setAttribute('src', src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=320');
    }
  }

  /* arrows for mouse users (horizontal lists are easy on a trackpad, not with a wheel) */
  var arrowLists = typeof WeakSet === 'function' ? new WeakSet() : null;
  var arrowIcon = function (d) { return '<svg viewBox="0 0 12 12" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true"><path d="' + d + '"/></svg>'; };
  function arrowState(list) {
    var max = list.scrollWidth - list.clientWidth;
    list.toggleAttribute('data-kd-start', list.scrollLeft <= 2);
    list.toggleAttribute('data-kd-end', list.scrollLeft >= max - 2);
    list.toggleAttribute('data-kd-fits', max <= 2);
  }
  /* measured while visible – a collapsed card reports zero widths */
  function refreshArrows() { [].forEach.call(root.querySelectorAll('.ab-bogo-products'), arrowState); }
  function addArrows(list) {
    if (!list) return;
    [['prev', 'M7.5 2.5 4 6l3.5 3.5', -1], ['next', 'M4.5 2.5 8 6 4.5 9.5', 1]].forEach(function (a) {
      if (list.querySelector(':scope > .kd-ab-arrow--' + a[0])) return;
      var wrap = document.createElement('span');
      wrap.className = 'kd-ab-arrow kd-ab-arrow--' + a[0];
      wrap.innerHTML = '<button type="button" aria-label="' + (a[2] < 0 ? (en ? 'Previous' : 'Atgal') : (en ? 'Next' : 'Toliau')) + '">' + arrowIcon(a[1]) + '</button>';
      wrap.firstChild.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        list.scrollBy({ left: a[2] * Math.max(list.clientWidth * 0.8, 140), behavior: 'smooth' });
      });
      list.appendChild(wrap);
    });
    if (arrowLists && !arrowLists.has(list)) {
      arrowLists.add(list);
      list.addEventListener('scroll', function () { arrowState(list); }, { passive: true });
    }
    arrowState(list);
  }

  /* wishlist button goes below the 2+1 card, the card follows the add-to-cart button */
  function moveWishlist() {
    if (!card.hasAttribute('data-kd-ready')) return;
    var wl = document.querySelector('product-form .frcp-wishlist-wrapper, form[action*="/cart/add"] .frcp-wishlist-wrapper');
    if (wl && wl.previousElementSibling !== card) { card.parentNode.insertBefore(wl, card.nextSibling); wl.classList.add('kd-ab-wishlist'); }
  }

  function update() {
    shrinkImages();
    var content = pickOffer();
    if (!content) return;
    var title = content.querySelector('.ab-bogo-title');
    if (title && !title.hasAttribute('data-kd-tag')) title.setAttribute('data-kd-tag', T.tag);
    var lists = content.querySelectorAll(':scope > .ab-bogo-products');
    var buy = lists[0], get = lists[1];
    if (!buy) return;
    var progress = (buy.querySelector('.ab-bogo-bundle-progress-text') || {}).textContent || '';
    var need = parseInt((progress.match(/(\d+)\s*$/) || [])[1], 10) || 2;
    var picked = buy.querySelectorAll('.ab-bogo-product-checkbox:checked').length;
    var step1 = T.pick(Math.min(picked, need), need);
    if (title && title.getAttribute('data-kd-step') !== step1) title.setAttribute('data-kd-step', step1);
    if (title) title.toggleAttribute('data-kd-done', picked >= need);
    var gap = get && get.previousElementSibling;
    if (gap && gap !== buy) {
      if (!gap.classList.contains('kd-ab-gap')) gap.classList.add('kd-ab-gap');
      var step2 = picked >= need ? T.gift : T.giftWait;
      if (gap.getAttribute('data-kd-step') !== step2) gap.setAttribute('data-kd-step', step2);
    }
    buildHead(content, get);
    var ht = card.querySelector('.kd-ab-title'), tt = title && title.textContent.trim();
    if (ht && tt && ht.textContent !== tt) ht.textContent = tt;
    var sub = card.querySelector('.kd-ab-sub'), save = saveText(content, get);
    if (sub && save && sub.innerHTML !== save) sub.innerHTML = save;
    addArrows(buy); addArrows(get);
    moveWishlist();
    var cur = currentCard(buy);
    if (cur && !cur.hasAttribute('data-kd-current')) cur.setAttribute('data-kd-current', '');
    if (cur && !preselected) {
      preselected = true;
      preselect(cur, 0);
      buy.scrollLeft = 0;
    }
  }

  /* the app attaches its handlers a moment after rendering – retry until the tick sticks */
  function preselect(item, tries) {
    setSelect(item.querySelector('.ab-bogo-select'), mainVariant());
    setTimeout(function () {
      var box = item.querySelector('.ab-bogo-product-checkbox');
      if (!box || box.disabled) return;
      if (!box.checked) box.click();
      if (box.blur) box.blur();
      setTimeout(function () {
        var list = item.parentNode; if (list) list.scrollLeft = 0;
        if (!box.checked && tries < 8) preselect(item, tries + 1);
      }, 250);
    }, 150);
  }

  var queued = false;
  new MutationObserver(function () {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () { queued = false; update(); });
  }).observe(root, { childList: true, subtree: true, attributes: true, attributeFilter: ['checked', 'disabled', 'src'] });
  root.addEventListener('change', function () { requestAnimationFrame(update); });
  update();
  /* the wishlist app injects its button after load */
  var wlTries = 0, wlTimer = setInterval(function () { moveWishlist(); if (++wlTries > 20) clearInterval(wlTimer); }, 500);
  window.addEventListener('resize', refreshArrows);

  /* keep the preselected card in sync with the main size picker */
  document.addEventListener('change', function (e) {
    if (root.contains(e.target)) return;
    setTimeout(function () {
      var cur = currentCard(active && active.querySelector(':scope > .ab-bogo-products'));
      if (cur) setSelect(cur.querySelector('.ab-bogo-select'), mainVariant());
    }, 60);
  });
})();
